var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-4 reports-tab-container" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-8" },
          [
            _c("label", { staticClass: "report-label" }, [
              _vm._v(_vm._s(_vm.$t("data_exports.invoices.date_range"))),
            ]),
            _vm._v(" "),
            _c("base-select", {
              attrs: {
                options: _vm.dateRange,
                "allow-empty": false,
                "show-labels": false,
              },
              on: { input: _vm.onChangeDateRange },
              model: {
                value: _vm.selectedRange,
                callback: function ($$v) {
                  _vm.selectedRange = $$v
                },
                expression: "selectedRange",
              },
            }),
            _vm._v(" "),
            _vm.$v.range.$error && !_vm.$v.range.required
              ? _c("span", { staticClass: "text-danger" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("validation.required")) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row report-fields-container" }, [
        _c(
          "div",
          { staticClass: "col-md-6 report-field-container" },
          [
            _c("label", { staticClass: "report-label" }, [
              _vm._v(_vm._s(_vm.$t("data_exports.invoices.from_date"))),
            ]),
            _vm._v(" "),
            _c("base-date-picker", {
              attrs: {
                invalid: _vm.$v.formData.from_date.$error,
                "calendar-button": true,
                "calendar-button-icon": "calendar",
              },
              on: {
                change: function ($event) {
                  return _vm.$v.formData.from_date.$touch()
                },
                input: _vm.setRangeToCustom,
              },
              model: {
                value: _vm.formData.from_date,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "from_date", $$v)
                },
                expression: "formData.from_date",
              },
            }),
            _vm._v(" "),
            _vm.$v.formData.from_date.$error &&
            !_vm.$v.formData.from_date.required
              ? _c("span", { staticClass: "text-danger" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("validation.required")) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 report-field-container" },
          [
            _c("label", { staticClass: "report-label" }, [
              _vm._v(_vm._s(_vm.$t("data_exports.invoices.to_date"))),
            ]),
            _vm._v(" "),
            _c("base-date-picker", {
              attrs: {
                invalid: _vm.$v.formData.to_date.$error,
                "calendar-button": true,
                "calendar-button-icon": "calendar",
              },
              on: {
                change: function ($event) {
                  return _vm.$v.formData.to_date.$touch()
                },
                input: _vm.setRangeToCustom,
              },
              model: {
                value: _vm.formData.to_date,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "to_date", $$v)
                },
                expression: "formData.to_date",
              },
            }),
            _vm._v(" "),
            _vm.$v.formData.to_date.$error && !_vm.$v.formData.to_date.required
              ? _c("span", { staticClass: "text-danger" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("validation.required")) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "  row report-fields-container" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "form-check" }, [
            _c("input", {
              ref: "hideCustomer",
              staticClass: "form-check-input",
              attrs: { id: "selectallSupplier", type: "checkbox" },
              on: { click: _vm.hideCustomer },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form-check-label",
                attrs: { for: "selectallSupplier" },
              },
              [
                _vm._v("\n            Select All\n            "),
                _vm.userType == "supplier" || _vm.userType == "funder"
                  ? _c("span", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$tc("customers.customer", 1)) +
                          "\n            "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.userType == "anchor"
                  ? _c("span", [_vm._v(_vm._s(_vm.$t("invoices.supplier", 1)))])
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.userType == "supplier" || _vm.userType == "funder"
        ? _c(
            "div",
            {
              staticClass: " disabled row report-fields-container",
              class: _vm.hidefields,
            },
            [
              _c(
                "div",
                { staticClass: "col-md-12 report-field-container" },
                [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$tc("customers.customer", 1)) + " "),
                  ]),
                  _vm._v(" "),
                  _c("base-customer-select", {
                    ref: "customerSelect",
                    on: {
                      select: _vm.onSelectCustomer,
                      deselect: _vm.clearCustomerSearch,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.userType == "anchor"
        ? _c(
            "div",
            {
              staticClass: "row disabled report-fields-container",
              class: _vm.hidefields,
            },
            [
              _c(
                "div",
                { staticClass: "col-md-12 report-field-container" },
                [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("invoices.supplier", 1))),
                  ]),
                  _vm._v(" "),
                  _c("base-select", {
                    attrs: {
                      options: _vm.suppliers,
                      searchable: true,
                      "show-labels": false,
                      "allow-empty": true,
                      tabindex: 8,
                      placeholder: _vm.$t("customers.type_or_click"),
                      label: "company_name",
                      "track-by": "company_id",
                    },
                    model: {
                      value: _vm.formData.user,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "user", $$v)
                      },
                      expression: "formData.user",
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row report-fields-container" },
        [
          _c("div", { staticClass: "col-md-12 mb-3" }, [
            _c("div", { staticClass: "form-check" }, [
              _c("input", {
                ref: "selectAllCheck",
                staticClass: "form-check-input",
                attrs: { id: "selectall", type: "checkbox" },
                on: {
                  click: function ($event) {
                    return _vm.selectAll()
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "selectall" },
                },
                [_vm._v("\n            Select All\n          ")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm._l(_vm.FilterReport, function (item) {
            return _c("div", { key: item, staticClass: "col-md-4" }, [
              _c("div", { staticClass: "form-check" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.viewcolumns,
                      expression: "formData.viewcolumns",
                    },
                  ],
                  staticClass: "form-check-input",
                  attrs: { id: item, type: "checkbox" },
                  domProps: {
                    value: item,
                    checked: Array.isArray(_vm.formData.viewcolumns)
                      ? _vm._i(_vm.formData.viewcolumns, item) > -1
                      : _vm.formData.viewcolumns,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.formData.viewcolumns,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = item,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.formData,
                              "viewcolumns",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.formData,
                              "viewcolumns",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.formData, "viewcolumns", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label",
                    attrs: { for: item },
                    on: {
                      change: function ($event) {
                        return _vm.$v.formData.viewcolumns.$touch()
                      },
                    },
                  },
                  [_vm._v("\n            " + _vm._s(item) + "\n          ")]
                ),
              ]),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row report-submit-button-container" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "base-button",
              {
                staticClass: "report-button",
                attrs: { outline: "", color: "theme" },
                on: {
                  click: function ($event) {
                    return _vm.getReports()
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("data_exports.update_data")) +
                    "\n        "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-sm-8 reports-tab-container" }, [
      _c("iframe", {
        staticClass: "reports-frame-style",
        attrs: { src: _vm.getReportUrl },
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "base-button btn btn-primary btn-lg report-view-button",
          on: { click: _vm.viewReportsPDF },
        },
        [
          _c("font-awesome-icon", {
            staticClass:
              "vue-icon icon-left svg-inline--fa fa-download fa-w-16 mr-2",
            attrs: { icon: "file-pdf" },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("data_exports.view_pdf")))]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }